import { Linking } from 'react-native';

const redirectToTerms = () => {
    Linking.openURL('https://www.one.hu/aszf');
};

export default redirectToTerms;
